import { ReactNode, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLongLeftIcon } from '@heroicons/react/24/outline';

// Layout for standalone pages (legal notice, news): slim header and a way back home.
const PageShell = ({ title, children }: { title: string; children: ReactNode }) => {
  useEffect(() => {
    const previous = document.title;
    document.title = `${title} · Nous'Rire`;
    window.scrollTo(0, 0);
    return () => { document.title = previous; };
  }, [title]);

  return (
    <div className="min-h-screen bg-paper">
      <header className="border-b border-ink/10 bg-paper-card">
        <div className="container mx-auto px-4 py-4 flex items-center justify-between gap-4">
          <Link to="/" className="flex items-center gap-3">
            <img src="/images/nousrire_logo.svg" alt="" className="h-9 w-auto" />
            <span className="heading text-xl">Nous'Rire</span>
          </Link>
          <Link to="/" className="inline-flex items-center gap-2 text-sm font-semibold text-accent hover:underline underline-offset-4">
            <ArrowLongLeftIcon className="h-5 w-5" /> Retour au site
          </Link>
        </div>
      </header>
      <main className="container mx-auto px-4 py-12 md:py-16">{children}</main>
    </div>
  );
};

export default PageShell;
